export default __webpack_public_path__ + "assets/images/0010a53d71e804730c273acb7a7e7db6.svg";